var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 129,
    viewBox: "0 0 145 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.001 7.99916C124.001 3.58096 127.582 -0.000737977 132.001 -0.000844981L137 -0.00096727C141.418 -0.00107427 145 3.58067 145 7.99903L145 109.999C145 120.492 136.493 128.999 126 128.999L20.5001 128.999C9.45439 129 0.500001 120.045 0.500003 108.999L0.500019 7.99919C0.50002 3.58099 4.08161 -0.000686802 8.49981 -0.000809066L13.5006 -0.000931354C17.9189 -0.00105362 21.5008 3.5807 21.5008 7.99906L21.5008 24.9994C21.5008 35.4928 30.0074 43.9994 40.5008 43.9994L105.001 43.9994C115.494 43.9994 124.001 35.4928 124.001 24.9994L124.001 7.99916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.f0d00bb15bc8e40770b43d581808b53f.svg";
export { ForwardRef as ReactComponent };